import { useEffect, useMemo } from "react";

const worker = new Worker("./worker.js");

// use a memoized event handler for onmessage!
export default function useWorker<Req, Res>(
	onmessage: (e: MessageEvent<Res>) => void,
) {
	useEffect(() => {
		worker.addEventListener("message", onmessage);
		return () => {
			worker.removeEventListener("message", onmessage);
		};
	}, [onmessage]);

	return useMemo(() => worker.postMessage.bind(worker), []) as (
		message: Req,
	) => void;
}
